
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, getAdditionalUserInfo } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB7HZXOTxHXW5gnxnDPP9xwxglHr7TQbeI",
  authDomain: "paperlens-d54ae.firebaseapp.com",
  projectId: "paperlens-d54ae",
  storageBucket: "paperlens-d54ae.firebasestorage.app",
  messagingSenderId: "409933484820",
  appId: "1:409933484820:web:20642858bf143be2a4e801",
  measurementId: "G-HQJQHMFXST"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
export { auth, googleProvider, signInWithPopup, signOut, getAdditionalUserInfo, analytics };


